module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/original-column-bg@3x-449be754456249c465d6949e412840c4.png";